import { createModel } from 'xstate/lib/model';

import baseEvents from 'common/bento/config/baseEvents';

import { BeneficiarySchema } from '../../../components/BeneficiaryForm/beneficiarySchema';
import { ApplicantType, ApplicationType } from '../../../types';
import { GetBeneficiariesDataQuery } from '../graphql/queries/getBeneficiariesData.gql';
import { BeneficiariesEmailSchemaValid } from '../pages/BeneficiariesEmail/form';
import { ManageBeneficiaryViews } from '../pages/ManageBeneficiary';

const initialContext = {
  getModuleData: () => {
    throw new Error('NOT_IMPLEMENTED');
  },
} as {
  getModuleData: () => GetBeneficiariesDataQuery & {
    applicationType: ApplicationType.Standard | ApplicationType.CapitalDeposit;
    applicantType: ApplicantType.AccountHolder | ApplicantType.Mandatee;
    showNewOnboardingBeneficiaryFlow: boolean;
    showSkipButton: boolean;
  };
};

const model = createModel(initialContext, {
  events: {
    ...baseEvents,
    CONFIRM_BENEFICIARIES: (data: {
      formValues: BeneficiariesEmailSchemaValid;
    }) => ({
      data,
    }),
    DELETE_BENEFICIARY: (data: {
      beneficiaryId: string;
      view: ManageBeneficiaryViews;
    }) => ({
      data,
    }),
    'done.invoke.deleteBeneficiary': (data: {
      name: string;
      gender: string;
    }) => ({ data }),
    'done.invoke.submitBeneficiaryForm': (data: {
      name: string;
      gender: string;
      view: ManageBeneficiaryViews;
    }) => ({ data }),
    'error.platform.registerCompanyBeneficiaries': (data: unknown) => ({
      data,
    }),
    'error.platform.sendAllCompanyInvitations': (data: unknown) => ({
      data,
    }),
    GO_MANAGE_BENEFICIARY: (data: {
      beneficiaryId: string | null;
      view: ManageBeneficiaryViews;
    }) => ({
      data,
    }),
    GO_MORAL_BENEFICIARY: () => ({}),
    SKIP_BENEFICIARY_LIST: () => ({}),
    SUBMIT_BENEFICIARY_FORM: (data: {
      beneficiaryId: string | null;
      view: ManageBeneficiaryViews;
      formValues: BeneficiarySchema;
    }) => ({
      data,
    }),
  },
});

export default model;

export type Context = typeof initialContext;
export type Model = typeof model;
